import { useEffect, useId, useRef } from "react";
import type { IResendSuccessProps } from "@b2bportal/core-self-serve/overridable";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { InfoBanner, InfoBannerSeverity } from "@tenant/ui";
import styles from "./ResendSuccess.module.scss";

export const ResendSuccess = ({ copy }: IResendSuccessProps) => {
  const [block, cn] = useModuleBEM(styles, "ResendSuccess");
  const titleRef = useRef<HTMLSpanElement>(null);
  const subtitleId = useId();

  // Move focus to the confirmation title on mount so AT announces it. Submitting
  // unmounts the form's focused button, orphaning focus, and Radix's focus scope
  // redirects that to the dialog close button. Running on the next frame lands
  // after Radix, so the heading keeps focus. aria-describedby pulls in the
  // subtitle so both lines are read.
  useEffect(() => {
    const raf = requestAnimationFrame(() => titleRef.current?.focus());
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className={block}>
      <InfoBanner
        severity={InfoBannerSeverity.SUCCESS}
        icon={IconNameEnum.checkFilled}
      >
        <span
          ref={titleRef}
          tabIndex={-1}
          aria-describedby={subtitleId}
          className={cn("title")}
        >
          {copy.success.title}
        </span>
      </InfoBanner>
      <p id={subtitleId} className={cn("subtitle")}>
        {copy.success.subtitle}
      </p>
    </div>
  );
};
